import { useAuth } from '@/hooks/useAuth'

export function useUserGroups() {
  return useAuth().groups
}
